import React from "react";
import { Box } from "@mui/material";

const SherpaLayout = ({ appSidebar, sidebar, header, children, composer }) => (
  <Box
    sx={{
      display: "flex",
      height: "100vh",
      bgcolor: "background.default",
      color: "text.primary",
      overflow: "hidden",
    }}
  >
    {appSidebar ? (
      <Box
        sx={{
          flexShrink: 0,
          display: { xs: "none", md: "flex" },
          minHeight: 0,
        }}
      >
        {appSidebar}
      </Box>
    ) : null}

    {sidebar ? (
      <Box
        sx={{
          width: 300,
          flexShrink: 0,
          display: { xs: "none", md: "flex" },
          flexDirection: "column",
          minHeight: 0,
          borderRight: "1px solid #DFECE5",
          bgcolor: "#F9FCFA",
        }}
      >
        {sidebar}
      </Box>
    ) : null}

    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0, minHeight: 0 }}>
      {header}
      <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
        {children}
      </Box>
      <Box
        sx={{
          px: { xs: 1.5, sm: 2.5 },
          pb: { xs: 1, sm: 2 },
          pt: 1.25,
          bgcolor: "#F7FBF8",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 900, mx: "auto" }}>{composer}</Box>
      </Box>
    </Box>
  </Box>
);

export default SherpaLayout;
